import { useCallback } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { OfferTypeSelectedItem } from './OfferTypeSelectedItem';
import OfferTypeItem, { IOfferTypeItemProps } from './OfferTypeItem';

export type OfferTypeSelectProps = {
  items: Omit<IOfferTypeItemProps, 'onClick'>[];
  value: string | null;
  disabled?: boolean;
  isChangeButtonVisible?: boolean;
  onChange: (value: string | null) => void;
};

const OfferTypeSelect = ({
  items,
  value,
  disabled,
  isChangeButtonVisible,
  onChange,
}: OfferTypeSelectProps) => {
  const onClick = useCallback(
    (itemValue: string | null) => {
      onChange(itemValue);
    },
    [onChange],
  );
  const selectedItem = items.find((item) => item.type === value);

  if (selectedItem) {
    return (
      <OfferTypeSelectedItem
        onClick={onClick}
        isChangeButtonVisible={isChangeButtonVisible}
        title={selectedItem.title}
        description={selectedItem.description}
        icon={selectedItem.icon}
      />
    );
  }

  return (
    <Grid container spacing={3}>
      {items.map((item) => (
        <Grid xs={12} sm={6} key={item.type}>
          <OfferTypeItem
            disabled={disabled}
            onClick={onClick}
            type={item.type}
            title={item.title}
            description={item.description}
            icon={item.icon}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default OfferTypeSelect;
